export const AdaptiveHeight = slider => {
  function updateHeight() {
    slider.container.style.transition = 'height 0.3s ease-in-out';
    const currentSlide = slider.slides[slider.track.details.rel];
    const firstChildren = currentSlide.children[0];
    if (firstChildren) {
      slider.container.style.height = firstChildren.offsetHeight + 'px';
    }
  }
  slider.on('created', updateHeight);
  slider.on('slideChanged', updateHeight);
};
